import { Component, OnInit } from '@angular/core';
import { CoursewareService } from 'src/services/CoursewareService';
import { MemberUserData } from 'src/model/User/MemberUserData';
import { Error } from 'src/model/Error';
import { AlertService } from '../_alert';
import { NgForm } from '@angular/forms';
import { Router } from '@angular/router';
import { globals } from '../shared/globals';
import { EditMemberViewModel } from 'src/model/EditMemberViewModel';


@Component({
  selector: 'app-account',
  templateUrl: './account.component.html',
  styleUrls: ['./account.component.css']
})
export class AccountComponent implements OnInit {
    public accountSettings: EditMemberViewModel = null;
    public isLoaded: boolean = false;

  constructor(private _router: Router, private coursewareService: CoursewareService, private alertService: AlertService) { }

  ngOnInit() {
    this.alertService.clear();
    this.coursewareService.getSettings(globals.token).subscribe(data => {
      this.accountSettings = data as EditMemberViewModel; 
      this.isLoaded = true;
      if (!this.accountSettings.EmailAddress){
        let error = data as Error
        this.alertService.error(error.Message);
        if (error.Message.indexOf("Invalid User") >= 0)
        {
            globals.token = null;
            globals.userName = null;
            if (typeof window !== 'undefined') {
              localStorage.removeItem('token');
              localStorage.removeItem('username');
            }   
        }
      }
    }, 
    error => this.alertService.error("Got unexpected error when getting account settings from server " + error.error));

  }

  public doSaveAccountSettings(form: NgForm)
  {
    this.alertService.clear();
    let theFirstName: string = form.value.firstName;
    let theLastName: string = form.value.lastName;
    let theEmail: string = form.value.email;
    if (theFirstName == null || theFirstName.length < 1)
        theFirstName = this.accountSettings.FirstName;
    if (theLastName == null || theLastName.length < 1)
        theLastName = this.accountSettings.LastName;
    if (theEmail == null || theEmail.length < 1)
        theEmail = this.accountSettings.EmailAddress;
    this.coursewareService.updateMemberUser(globals.token, theFirstName, theLastName, theEmail).subscribe(data => {
        if (data != "SUCCESS")
        {
            let error = data as Error
            this.alertService.error(error.Message);
        }
    }, 
    error => this.alertService.error("Got unexpected error when saving account settings to server " + error.error));
  }

  public changePassword(form: NgForm)
  {
    this.alertService.clear();
    if (form.value.password == null || form.value.password.length < 1 ||  form.value.password != form.value.changePassword)
    {
        this.alertService.error("Cannot change password - passwords not be empty and must be identical");
        return
    }
    this.coursewareService.updatePassword(globals.token, form.value.password).subscribe(data => {
        if (data != "SUCCESS")
        {
            let error = data as Error
            this.alertService.error(error.Message);
        }
    }, 
    error => this.alertService.error("Got unexpected error when updating password on the server " + error.error));
  }

  public cancelAccount()
  {
    this.alertService.clear();
    this.coursewareService.closeAccount(globals.token).subscribe(data => {
        if (data != "SUCCESS")
        {
            let error = data as Error
            this.alertService.error(error.Message);
        } else{
            globals.token = null;
            globals.userName = null;
            if (typeof window !== 'undefined') {
              localStorage.removeItem('token');
              localStorage.removeItem('username');
            }
            this.alertService.info("Your account has been closed.")
            this._router.navigate(["/homeview"]);
        }
    }, 
    error => this.alertService.error("Got unexpected error when updating password on the server " + error.error));
  }
}
